<template>
  <div class="background" :class="{'longCont1':long}">
  <div class="chart-container" :class="{'longCont':long}">
    <div @click="printPdf" class="noPrint">{{$t('print')}}</div>
    <div class="Hcp-main-header">
      <div class="main-header-left">
        <img src="../../assets/LOGO.png">
      </div>
      <div class="main-header-right">
        <p>{{$t('dayBydayRe')}}</p>
        <p style="font-size: 13px;">{{$t('period')}}: {{staTime}}-{{endTime}}</p>
      </div>
    </div>
    <table class="status-table1" :class="{'zh11':!isEn,'de1':isDe||isIt||isFr}">
      <tr>
        <td class="td1 td2">{{$t('uername')}}</td><td colspan="4" class="td2">{{statics.username}}</td>
        <td class="td1 td2">{{$t('fullName')}}</td><td colspan="4" class="td3">{{statics.name}}</td>
      </tr>
      <tr>
        <td rowspan="3" class="td1 td2">{{$t('devices')}}</td>
        <td class="td2" id="reportPdmTitle">{{$t('pdm')}}</td><td colspan="8" class="td3">{{devices[0]}}</td>
      </tr>
      <tr><td class="td2">{{$t('tran')}}</td><td colspan="8" class="td3">{{devices[1]}}</td></tr>
      <tr><td class="td2">{{$t('pumpBase')}}</td><td colspan="8" class="td3">{{devices[2]}}</td></tr>  <!-- pump_device -->
      <tr>
        <td class="td1 td4">{{$t('disType')}}</td><td colspan="9" class="td4">{{statics.medical_history}}</td>
        <!--<td class="td td4">{{$t('HbA1c')}}</td><td colspan="4">{{hb1c[0]}}</td>-->
      </tr>
    </table>

    <div class="small-hr"></div>
    <div v-for="(base, p) in pagePos">

      <div v-if="p==1">
        <div style="clear: both"></div>
        <div class="page-seperator"></div>

        <div class="page-starter">
          <!--<br/><br/><br/><br/>-->
        </div>
      </div>

      <div class="page-charts">
        <div v-for="(url,index) in src2_1.slice(base, base+perPage[p])" class="imgCotain">
          <!-- -->
          <div class="date date-spe3"> <span >{{date[base+index]}}</span></div>
          <div class="eat-label eat-spe3" :class="{'zh1':!isEn,'de11':isDe,'po1':isPo||isFr}">
            <span class="eat-label-spe1" :class="{'zh2':!isEn,'de2':isDe,'po2':isPo||isFr}" >{{$t('Breakfast')}}</span>
            <span :class="{'zh3':!isEn,'de3':isDe,'po3':isPo||isFr}">{{$t('Lunch')}}</span>
            <span  :class="{'zh4':!isEn}">{{$t('Dinner')}}</span>
          </div>
          <img :src=url class="img">
          <div class="carb">
            <span>{{$t('carbs')}}(g)</span>
            <div :id="'carb'+(base+index)">
              <label v-for="i in carb[base+index]">{{i[1]}}</label>
              <img class="breakfast" v-for="b in autoBreakfast[base+index]" src="/static/legend/automode/早餐.png"/>
              <img class="lunch" v-for="b in autoLunch[base+index]" src="/static/legend/automode/中餐.png"/>
              <img class="dinner" v-for="b in autoDinner[base+index]" src="/static/legend/automode/晚餐.png"/>
              <img class="snack" v-for="b in autoSnack[base+index]" src="/static/legend/automode/零食.png"/>
            </div>
          </div>
          <img :src=src2_2[base+index] class="img">
        </div>
      </div>

    </div>

    <div v-if="chartEndPage.show">
      <div style="clear: both"></div>
      <div class="page-seperator"></div>
      <div class="page-starter">
        <!--<br/><br/><br/><br/>-->
      </div>
    </div>

    <hr class="small-hr">
    <div class="legend-group" :class="{'zh5':!isEn,'it5':isIt,'po5':isPo,'du5':isDu||isFr||isCz}">
      <div class="legend"><img src="../../assets/Hcp-icon/legend/Alert.png"><span>{{$t('alert')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/target.png"><span>{{$t('target')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/hypo.png" class="img-spe"><span>{{$t('hypo')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/SG.png" class="img-spe"><span>{{$t('sensorGlucose')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/calib.png"><span>{{$t('calib')}}</span></div>
      <div class="legend "><img src="../../assets/Hcp-icon/legend/transmitter.png"><span>{{$t('newSen')}}</span></div>
      <div class="legend legend-spe1"><img src="../../assets/Hcp-icon/legend/warm up.png"><span>{{$t('warm')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh6':!isEn}"><img src="../../assets/Hcp-icon/legend/basal.png"><span>{{$t('basal')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh7':!isEn}"><img src="../../assets/Hcp-icon/legend/temp basal.png"><span>{{$t('tampBasal')}}</span></div>
      <div class="legend legend-spe3" :class="{'zh8':!isEn}"><img src="../../assets/Hcp-icon/legend/normal bolus.png"><span>{{$t('normalBolus')}}</span></div>
      <div class="legend legend-spe4" :class="{'zh9':!isEn}"><img src="../../assets/Hcp-icon/legend/extend bolus.png"><span>{{$t('extendBolus')}}</span></div>
      <div class="legend legend-spe5" :class="{'zh10':!isEn}"><img src="../../assets/Hcp-icon/legend/auto suspend.png"><span class="span1">{{$t('manualStop')}}</span></div>
      <div class="legend legend-spe1" :class="{'zh11':!isEn}"><img src="../../assets/Hcp-icon/legend/Auto Suspend 2.png"><span class="span1">{{$t('autoStop')}}</span></div>
      <div class="legend legend-spe1"><img src="../../assets/Hcp-icon/legend/patch Deactivated.png"><span>{{$t('stop')}}</span></div>
      <div class="legend legend-spe6" :class="{'zh12':!isEn}"><img src="../../assets/Hcp-icon/legend/new Patch.png"> <span>{{$t('newPatch')}}</span></div>
      <div class="legend legend-spe7" :class="{'zh13':!isEn}" ><img src="../../assets/Hcp-icon/legend/carbs.png"><span>{{$t('carbs')}}</span></div>
      <div class="legend legend-spe2" :class="{'zh14':!isEn}"><img src="../../assets/Hcp-icon/legend/exercise.png"><span>{{$t('exercise')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/calibrate_1.png"><span>{{$t('BG Reading')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/早餐.png"><span>{{$t('Breakfast')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/中餐.png"><span>{{$t('Lunch')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/晚餐.png"><span>{{$t('Dinner')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/零食.png"><span>{{$t('t1222_Snack')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/icon_histogram.png"><span>{{$t('t1222_auto_basal')}}</span></div>
      <div class="legend"><img src="../../assets/Hcp-icon/legend/automode/auto_bolus.png"><span>{{$t('t1222_auto_bolus')}}</span></div>
    </div>

    <div class="page-end"></div>
  </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
    import format from '@/lib/format'
  import B64 from '../../auth/base64'
  export default {
    data() {
      return {
        pump_device:'--',
        uid:0, st:0,et:0,isEn:false,ts:[],
        timeSection:[],staTime:'',endTime:'',
        src2_1:[], src2_2:[], date:[],carb:[],isFr:false,
        autoBreakfast:[],
        autoLunch:[],
        autoDinner:[],
        autoSnack:[],
        isDu:false,isCz:false,
        pagePos:[],perPage:[],
        chartEndPage:{show:false},
        statics:{},devices:['--','--','--'],hb1c:['--'],long:false,isMg:"",isDe:false,isIt:false,isPo:false,
      }
    },
    computed: {
      DataD(){
        return this.$store.state.DataD;
      },
      DataSG(){
        return this.$store.state.DataSG;
      },
      DataBasal(){
        return this.$store.state.DataBasal;
      },
      DataBolus(){
        return this.$store.state.DataBolus;
      },
    },
    methods: {
      makeCarb(){
        let carbs = this.carb;
        let time = this.timeSection;
        for(let i=0;i<carbs.length;i++){
          if(carbs[i].length>0){
            for(let j =0;j<carbs[i].length;j++){
              let t1 = 0;
              let w =0;
              t1 =carbs[i][j][0]-time[i][0];
              w = (t1/864).toFixed(1)+'%';
              let id = 'carb'+i;
              const OBJ = document.getElementById(id);
              const label= OBJ.getElementsByTagName('label');
              label[j].style.zIndex = 100+i+j;
              label[j].style.left = w;
            }
          }
        }

        // 自动模式早餐
        let className=['breakfast', 'lunch', 'dinner', 'snack'];
        let autoMeal=[this.autoBreakfast, this.autoLunch, this.autoDinner, this.autoSnack];

        for(let i=0; i<className.length; i++) {

          for (let d=0; d<autoMeal[i].length; d++) {
            for (let j=0; j<autoMeal[i][d].length; j++) {
              let t1 = 0;
              let w =0;
              t1 =autoMeal[i][d][j][0]-time[d][0];
              w = (t1/864).toFixed(1)+'%';
              let id = 'carb'+d;
              const OBJ = document.getElementById(id);
              const label= OBJ.getElementsByClassName(className[i])
              console.log('autoMeal:', OBJ, label, className[i])
              label[j].style.zIndex = 100+d+j;
              label[j].style.left = w;
            }
          }
        }

      },
      getDate(){
        for(let i=0;i<this.date.length;i++){
          let day = this.st+i*86400;
          let time =(this.isEn)?format.formatterDate4(day):format.formatterDate3(day);
          let weeks =  format.formatterDay(this,day);
          this.date[i] =time+' '+weeks;
        }
         let t1 = this.date[0].split(' ')[0].split('-');
         this.staTime =t1[0]+'/'+t1[1]+'/'+t1[2];
         let t2 = this.date[this.date.length-1].split(' ')[0].split('-');
        this.endTime =t2[0]+'/'+t2[1]+'/'+t2[2];
      },
      getStatics(param){
        this.$http.get('api/v2.1/report/'+this.uid+'/data/dd',{params:{param}}).then(function (res) {
          let err =res.body.error;
          if(err === 0){
            let data =  res.data.data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            if ('EasyPatch'==this.devices[0]) {
              document.getElementById('reportPdmTitle').innerHTML='APP';
            }
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
          }
        },function(err){
          let tip =  this.$t('tryAgain');
          this.$message.error(tip);
        })
      },
      getStatics2(report_data){
            let data =  report_data;
            data.medical_history = (data.medical_history )?this.$t(data.medical_history):"--";
            this.statics = data;
            this.devices = (data.devices)?data.devices:this.devices;
            this.hb1c = (data.hba1c)?data.hba1c:this.hb1c;
      },
      printPdf(){
        auth.print_page();
      },
    },
    mounted: function () {
      self.document.title = this.$t('dayBydayRe');
      let lang = sessionStorage.getItem('language');
      this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
      this.isDe = (lang==='de')?true:false;
      this.isIt = (lang==='it')?true:false;
      this.isPo = (lang==='po')?true:false;
      this.isFr = (lang==='fr')?true:false;
      this.isDu = (lang==='du')?true:false;
      this.isCz = (lang==='cz')?true:false;
      this.isMg = (localStorage.getItem('unit')==='mg')?true:false;
      this.st = parseInt(sessionStorage.getItem('st2'));
      this.et = parseInt(sessionStorage.getItem('et2'));
      this.ts = auth.getTs(this.st,this.et);
      let param = {
        ts:this.ts,
        tz:parseInt(sessionStorage.getItem('tz')),
        gu:(this.isMg)?'mg/dL':'mmol/L',
      };
      if(sessionStorage.getItem('userType')!=='P'){
        this.uid = parseInt(sessionStorage.getItem('patientId'));
      }else{
        this.uid = parseInt(sessionStorage.getItem('uid'));
      }
      param = B64.base64encode(JSON.stringify(param));
      this.src2_1 = JSON.parse(sessionStorage.getItem('src2_1'));
      this.src2_2 = JSON.parse(sessionStorage.getItem('src2_2'));
      this.pump_device=sessionStorage.getItem('dd_pump_device')
      // 计算分页信息
      /*this.pagePos.push(0);   // 第一页的图表索引的基值是0
      if (this.src2_1.length>9) {  // 大于9页需要分页，第一页显示9个图表。
        this.pagePos.push(9);  // 第一页的图表索引的基值是9
      }*/

      /* */
      let page_index=0;
      let PER_PAGE1=9;
      let PER_PAGE2=9;
      //let PER_PAGE=100;   // equivalent to previous
      while (page_index < this.src2_1.length) {
        //let page_date=whichDate.slice(page_index, page_index+PER_PAGE);
        //whichDatePage.push(page_date, page_index)
        this.pagePos.push(page_index);
        if (1==this.pagePos.length) {
          page_index += PER_PAGE1;
          this.perPage.push(PER_PAGE1);
        } else {
          page_index += PER_PAGE2;
          this.perPage.push(PER_PAGE2);
        }
      }
      let chartNum=this.src2_1.length;
      if (chartNum>6 && chartNum<=9) {
        this.chartEndPage.show=true;
      }
      console.log('pagePos:', this.pagePos, chartNum, this.chartEndPage.show);

      this.date = JSON.parse(sessionStorage.getItem('date2_2'));
      if(this.date.length>9){
         this.long =true;
      }
      this.carb = JSON.parse(sessionStorage.getItem('carb2_2'));
      this.autoBreakfast = JSON.parse(sessionStorage.getItem('autoBreakfast2_2'));
      this.autoLunch = JSON.parse(sessionStorage.getItem('autoLunch2_2'));
      this.autoDinner = JSON.parse(sessionStorage.getItem('autoDinner2_2'));
      this.autoSnack = JSON.parse(sessionStorage.getItem('autoSnack2_2'));
      this.timeSection = JSON.parse(sessionStorage.getItem('timeS2_2'));
      let report_data = JSON.parse(sessionStorage.getItem('dd_report_data'));
      this.getStatics2(report_data);
      //this.getStatics(param);
      this.getDate();
      let timer = setTimeout(this.makeCarb,1000);
      setTimeout(auth._printPdf(),2000);
    },
  }
</script>

<style scoped meadia="print">
  @page{
    *size:auto;
    size:portrait;
    margin: 0;
  }
  .background{
    padding-top: 5mm;
    width: 100%;
    *height: 600mm;
    background: #ccc;
  }
  .background .noPrint{
    float: left;
    border-radius:100px;
    background: #fff;
    border: 1px solid #a3a3a3;
    outline: none;
    margin-top:4px;
    width:90px;
    height:26px;
    line-height: 28px;
    cursor: pointer;
    margin-left:-140px;
    font-size: 13px;
    text-align: center;
  }
  @media print {
    .background .noPrint{
      display: none;
    }
  }
  .chart-container {
    width:210mm;
    *min-height: 600mm;
    font-family:SFUIText-Regular;
    font-size:13px;
    color:#282828;
    letter-spacing:-0.34px;
    background: #fff;
    margin:0 auto;
    padding-left: 20px;
    padding-right: 20px;
  }
  .longCont1{
    *height: 604mm;
  }
  .longCont{
    *height: 594mm;
  }
  .Hcp-main-header{
    width:97%;
    height:40px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:12px;
    color:#282828;
    padding-top: 10px;
  }
  .main-header-left{
    float: left;
  }
  .main-header-left img{
    height:45px;
    width: 100px;
  }
  .main-header-right{
    float: right;
    text-align: right;
    padding-top: 10px;
    margin-right: 15px;
  }
  .main-header-right p{
    font-size:12px;
    margin-bottom: 5px;
    letter-spacing:-0.29px;
    font-family:SFUIText-Regular;
    color:#282828;
  }
  .status-table1{
    width: 94%;
    margin:20px auto 16px;
    border:1px solid #747474;
    font-family:SFUIText-Regular;
    border-collapse: collapse;
    text-align:left;
    table-layout: fixed;
    font-size:12px;
  }
  .status-table1 td{
    padding-left: 8px;
    height:15px;
  }
  .status-table1 .td1{
    width: 14%;
  }
  .zh11 .td1{
    width: 12%;
  }
  .de1 .td1{
    width: 11%;
  }
  .de1 td{
    padding-left: 3px;
  }
  .status-table1 .td2{
    border-bottom:1px solid rgba(116,116,116,0.34);
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td3{
    border-bottom:1px solid rgba(116,116,116,0.34);
  }
  .status-table1 .td4{
    border-right:1px solid rgba(116,116,116,0.34);
  }
  .small-hr{
    width:94%;
    margin:10px auto 15px;
    border-top:1px solid #3b3b3b;
  }

  .imgCotain{
    margin-left: 1%;
    *height: 285px;
    height:70mm;
    width: 32%;
    float:left;
  }
  .date{
    width:33%;
    float:left;
    font-size:16px;
    color:#0082d2;
    letter-spacing:-0.39px;
    line-height:13px;
    text-align:center;
  }
  .date-spe3{
    width:80%;
    margin-left: 9%;
  }
  .img{
    width:100%;
    height:130px;
  }
  .eat-label{
    font-size:12px;
    color:#282828;
    letter-spacing:-0.29px;
    width:33%;
    margin:8px 0 -2px 0;
    text-align:center;
    float: left;
  }
  .eat-spe3{
    width:70%;
    margin-left: 23%;
  }
  .eat-label span{
    margin-right:8%;
  }
  .zh1{
    margin-left: 18%;
  }
  .zh1 .zh2{
    margin-right: 15%;
  }
  .zh1 .zh3{
    margin-right: 15%;
  }
  .zh1 .zh4{
    margin-right: 0;
  }
  .de11{
    width: 90%;
    margin-left: 14%;
  }
  .de11 .de2{
    margin-right: 3%;
  }
  .de11 .de3{
    margin-right: 2%;
  }
  .po1{
    width: 90%;
    margin-left: 4%;
  }
  .po1 .po2{
    margin-right: 3%;
  }
  .po1 .po3{
    margin-right: 2%;
  }

  .carb{
    width:85.2%;
    margin:-40px 0 5px 8%;
    height:20px;
    line-height: 20px;
    padding-left: 5px;
    border: 1px solid #ccc;
    position: relative;
  }
  .carb span{
    float: left;
  }
  .carb label{
    display: inline-block;
    border:1px solid #00ff4c;
    border-radius:4px;
    width:20px;
    height:15px;
    line-height: 15px;
    float: left;
    position: absolute;
    font-size:13px;
    color:#000;
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 2px;
    background-color: #00ff4c;
    font-family:SFUIText-Regular;
  }

  .page-seperator {
    *height:5cm;
    *height:20mm;
    page-break-before: always;
  }

  .page-starter {
    height:10mm;
  }

  .page-end {
    clear: both;
    height:10mm;
  }

  .legend-group{
    width:96%;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .legend{
    float:left;
    margin-bottom: 8px;
    margin-right:60px;
    height:20px;
    line-height: 20px;
  }
  .zh5 .legend{
    margin-right:70px;
  }
  .legend img{
    margin-right: 8px;
  }
  .legend-spe1{
    margin-right: 38px;
  }
  .legend-spe2{
    margin-bottom: 1px;
  }
  .legend-spe3{
    margin-right: 18px;
  }
  .legend-spe4{
    margin-right: 53px;
  }
  .legend-spe5{
    margin-right: 15px;
  }
  .legend-spe6{
    margin-right: 30px;
  }
  .legend-spe7{
    margin-right: 83px;
  }
  .legend-group .span1{
    margin-bottom: 2px;
    display: block;
    float: right ;
  }
  .img-spe{
    margin-bottom: 4px;
  }
  .zh5 .zh6{
    margin-right: 45px;
  }
  .zh5 .zh7{
    margin-right: 60px;
  }
  .zh5 .zh8{
    margin-right: 33px;
  }
  .zh5 .zh9{
    margin-right: 48px;
  }
  .zh5 .zh10{
    margin-right: 30px;
  }
  .zh5 .zh11{
    margin-right: 56px;
  }
  .zh5 .zh12{
    margin-right: 56px;
  }
  .zh5 .zh13{
    margin-right: 114px;
  }
  .zh5 .zh14{
    margin-right: 88px;
  }

  .it5 .legend{
    margin-right:40px;
  }

  .po5 .legend{
    margin-right:40px;
  }
  .du5 .legend{
    margin-right:40px;
  }
</style>



// WEBPACK FOOTER //
// chart2_print.vue?0b7675cc